var _svg;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

// This file is automatically generated from generateIllustrations.js
import * as React from 'react';
import IllustrationContainer from '../IllustrationContainer.js';

function CheckmarkIllustration(props) {
  return /*#__PURE__*/React.createElement(IllustrationContainer, _extends({}, props, {
    children: _svg || (_svg = /*#__PURE__*/React.createElement("svg", {
      width: "100%",
      height: "100%",
      viewBox: "0 0 128 128",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M124.18 64c0 21.774-11.613 40.839-28.936 51.387C86.147 120.903 75.502 124 64.18 124 32.63 124 6.696 99.613 4.373 68.645 4.276 67.097 4.18 65.548 4.18 64c0-33.097 26.903-60 60-60 22.451 0 42.096 12.387 52.355 30.677A59.883 59.883 0 01124.18 64zM3.181 68.725l-.197.098",
      stroke: "currentColor",
      strokeWidth: 3,
      strokeMiterlimit: 10
    }), /*#__PURE__*/React.createElement("path", {
      d: "M55.399 70.174l30.68-32.492c.837-.887 2.265-.823 3.047.113 2.1 2.516 4.18 4.726 6.575 7.254.73.77.73 1.974.003 2.746L55.457 90.46a2 2 0 01-2.908.002L32.3 69.054a2 2 0 010-2.749l6.813-7.202a2 2 0 012.906 0L52.49 70.175a2 2 0 002.908-.001z",
      fill: "#009CEB"
    })))
  }));
}

export default CheckmarkIllustration;